'use strict';
define(['app'], function (app) {
    app.component('stProjectSectionHeading', {
        templateUrl: 'app/components/st-project-section-heading/st-project-section-heading.html',
        bindings: {
            eyebrow: '@',
            icon: '@',
            title: '@',
            subtitle: '@'
        }
    });
});
